export default "__VITE_ASSET__ucc2F_ea__"